<template>
    <tr
        v-if="!assignedorderids.includes(order.id)"
        :class="['deliveryItem', { notactive: checkifactive(group.date) }, {'assigningorder' : assignorder && assignorder.id == order.id}]"
    >

        <td>
            <div class="OrderInfo">
                

                <div class="itemSize">
                    <span class="itemNumber">
                        {{ order.numberofboxes }}
                    </span>
                    <span class="doz"> DOZ </span>
                </div>
            </div>
        </td>

        <td>
            {{ order.contact_name }}
        </td>

        <td>
            {{ order.phone_number | VMask("(###) ###-####") }}
        </td>

        <td>
            {{
                order.order_event_time_range
                    ? `${order.order_event_time_range}, `
                    : ""
            }}
            {{ order.delivery_date | formatdate("MMM D") }}
        </td>

        <td>
            <div class="deliveryInfo">
                <b-row no-gutters>
                    <b-col cols="3" md="2">
                        <div class="googleMap" @click="openMap('point', order)">
                            <GmapMap
                                :options="mapOptions"
                                :center="{
                                    lat: parseFloat(
                                        order.shipping_address_latitude
                                    ),
                                    lng: parseFloat(
                                        order.shipping_address_longitude
                                    ),
                                }"
                                :zoom="10"
                                map-type-id="roadmap"
                            >
                                <GmapMarker
                                    :icon="svgMarker"
                                    :position="{
                                        lat: parseFloat(
                                            order.shipping_address_latitude
                                        ),
                                        lng: parseFloat(
                                            order.shipping_address_longitude
                                        ),
                                    }"
                                />
                            </GmapMap>
                        </div>
                    </b-col>

                    <b-col cols="8" md="8">
                        <div class="deliveryDateandTime">
                            <div class="dAddress">
                                {{ order.shipping_address_street }}
                                {{ order.shipping_address_city }}
                                {{ order.shipping_address_state }}
                                {{ order.shipping_address_zipcode }}
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </td>

        <td>
             <div
                @click.prevent="
                    $emit('update:assignorder', order),
                    $emit('update:showAssignPop', true)
                "
                class="deliverAssign"
            >
                 <b-iconstack font-scale="1.25">
                    <b-icon
                        stacked
                        icon="plus"
                        scale="0.75"
                    ></b-icon>
                    <b-icon stacked icon="circle"></b-icon>
                </b-iconstack>
            </div>
        </td>
    

    </tr>
</template>

<script>
// plugins
import moment from "moment";

// Helpers
import Helper from "@/helpers/helper.js";

//Mixins
import { mapMixins } from "@/mixins/mapMixins";
import { ordermixins } from "@/mixins/ordermixins";

export default {
    mixins: [mapMixins, ordermixins],
    props: {
        assignorder: {
            type: Object,
            default: () => null,
        },
        showAssignPop: {
            type: Boolean,
            default: () => false,
        },
        group: {
            type: Object,
            default: () => null,
        },
        order: {
            type: Object,
            default: () => null,
        },
        assignedorderids: {
            type: Array,
            default: () => [],
        },
    },
    filters: {
        /**
         * Format date by
         * @param format
         */
        formatdate(date, format) {
            return date ? Helper.formatdate(date, format) : "";
        },
        /**
         * Format date by relation like
         * Today, Tomorrow, and MM/DD/YYYY
         */
        formatreldate(date) {
            return Helper.datestring(date);
        },
    },
    methods: {
        /**
         * check order delivery date
         * if not today or tomorrow disable event pointer and grayed out the order
         */
        checkifactive(date) {
            /**
             * If orderdate is past due
             * make it active
             */
            if(date == 'pastdue') {
                return false
            }
            /**
             * Check if order is for tomorrow or today
             */
            const todaysdate = Helper.isUStimezone()
                ? moment().format("MM/DD/YYYY")
                : Helper.formatdate(moment(), "MM/DD/YYYY");
            if (moment(date).isSame(todaysdate, "day")) {
                return false;
            } else if (
                moment(date).isSame(moment(todaysdate).add(1, "day"), "day")
            ) {
                return false;
            } else {
                return true;
            }
        },
    },
    /**
     * Run function before component render
     */
    async beforeMount() {
        // Google map
        this.$gmapApiPromiseLazy().then(() => {
            this.initMap();
        });
    },
};
</script>

<style lang="scss">


</style>
